
import { chartIntervalStateHandler } from '@/mixins';
import FormatterService from "@/service/FormatterService";
import ShareService from '@/service/ShareService';

export default {
    name: "ShareIntervalSelector",

    mixins: [
        chartIntervalStateHandler,
    ],

    props: {
        intervals: {
            type: Array,
            required: true
        },
        interval: {
            type: String,
            default: 'day'
        },
        isin: {
            type: String,
            default: ''
        }
    },

    emits: ['update:interval'],

    data() {
        return {
            performance: {},
        }
    },

    watch: {
        isin() {
            this.fetchData()
        },
        interval() {
            this.fetchData()
        },
    },

    created() {
        this.formatter = new FormatterService();
        this.shareService = new ShareService(this.$axios);

        this.fetchData();
    },

    methods: {
        async fetchData() {
            try {
                if (!this.isin) {
                    return;
                }
                const data = await this.shareService.getSharePerformance(this.isin);
                this.performance = data.performance;
            } catch (error) {
                this.performance = {};
            }
        },
        onIntervalClick(interval) {
            this.changeInterval(interval);
            this.$emit('update:interval', interval);
        },
        getColorClass(value) {
            if (!value) {
                return 'text-neutral'
            } else if (value > 0) {
                return 'text-positive'
            } else if (value < 0) {
                return 'text-negative'
            }
        },
    },
}
